import superjson from 'superjson'

export { type SuperJSONResult } from 'superjson/dist/types'
export const transformer = superjson
